import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "footer-extended context-dark bg-900"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "row row-30"
};
const _hoisted_4 = {
  class: "col-md-8"
};
const _hoisted_5 = {
  class: "logo footer-logo mt-2",
  style: {
    "max-width": "250px"
  }
};
const _hoisted_6 = {
  class: "row row-10 row-content"
};
const _hoisted_7 = {
  class: "col-12 col-md-6 col-lg-6"
};
const _hoisted_8 = {
  class: "list list-sm"
};
const _hoisted_9 = {
  class: "link link-inherit"
};
const _hoisted_10 = {
  class: "link link-inherit"
};
const _hoisted_11 = {
  class: "col-12 col-md-6 col-lg-6"
};
const _hoisted_12 = {
  class: "list list-sm"
};
const _hoisted_13 = {
  class: "link link-inherit"
};
const _hoisted_14 = {
  class: "link link-inherit"
};
const _hoisted_15 = {
  class: "row row-10 big"
};
const _hoisted_16 = {
  class: "col-lg-6"
};
const _hoisted_17 = {
  class: "term-list term-list-inline"
};
const _hoisted_18 = {
  class: "link link-inherit"
};
const _hoisted_19 = {
  class: "col-lg-6"
};
const _hoisted_20 = {
  class: "group-10 group-x-50 d-flex flex-wrap"
};
const _hoisted_21 = {
  class: "term-list term-list-inline"
};
const _hoisted_22 = {
  class: "link link-inherit"
};
const _hoisted_23 = {
  class: "term-list term-list-inline"
};
const _hoisted_24 = {
  class: "link link-inherit"
};
import { ref, onMounted } from 'vue';
import { addressList } from '@/api/home/index';
export default {
  __name: 'Footer',
  setup(__props) {
    const centerAddress = ref({
      city: '石家庄总部',
      address: '河北省石家庄市桥西区石铜路11号冀华律师楼',
      phone: '0311-85288005',
      email: 'jihua666666@163.com'
    });
    const dataList = ref([]);
    const getData = async () => {
      const data = await addressList();
      centerAddress.value = data.shift();
      dataList.value = data;
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_router_link, {
        class: "logo-link",
        to: "/"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("img", {
          class: "logo-image-inverse",
          src: "/images/logo.png",
          alt: "Lawex"
        }, null, -1)])),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value.slice(0, 3), item => {
        return _openBlock(), _createElementBlock("li", {
          class: "list-item",
          style: {
            "display": "flex",
            "flex-direction": "column"
          },
          key: item.id
        }, [_createElementVNode("span", _hoisted_9, _toDisplayString(item.city) + "：" + _toDisplayString(item.address), 1), _createElementVNode("span", _hoisted_10, "电 话：" + _toDisplayString(item.phone), 1)]);
      }), 128))])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("ul", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value.slice(3, 6), item => {
        return _openBlock(), _createElementBlock("li", {
          class: "list-item",
          style: {
            "display": "flex",
            "flex-direction": "column"
          },
          key: item.id
        }, [_createElementVNode("span", _hoisted_13, _toDisplayString(item.city) + "：" + _toDisplayString(item.address), 1), _createElementVNode("span", _hoisted_14, "电 话：" + _toDisplayString(item.phone), 1)]);
      }), 128))])])])]), _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"col-md-4\" style=\"display:flex;justify-content:center;align-items:center;\"><div class=\"row row-10 row-content\"><div class=\"col-6 col-md-12 col-lg-6\" style=\"display:flex;flex-direction:column;align-items:center;\"><img src=\"/images/official.jpg\" width=\"136\" height=\"136\" alt=\"\"><span>企业公众号</span></div><div class=\"col-6 col-md-12 col-lg-6\" style=\"display:flex;flex-direction:column;align-items:center;\"><img src=\"/images/zixunwechat.jpg\" width=\"136\" height=\"136\" alt=\"\"><span>咨询微信</span></div></div></div>", 1))]), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "divider footer-divider footer-divider-1"
      }, null, -1)), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString(centerAddress.value.city) + "：" + _toDisplayString(centerAddress.value.address), 1)])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", null, [_createElementVNode("dl", _hoisted_21, [_createElementVNode("span", _hoisted_22, "电话: " + _toDisplayString(centerAddress.value.phone), 1)])]), _createElementVNode("div", null, [_createElementVNode("dl", _hoisted_23, [_createElementVNode("span", _hoisted_24, "邮箱: " + _toDisplayString(centerAddress.value.email), 1)])])])])]), _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"divider footer-divider\"></div><div class=\"row row-15\"><div class=\"col-sm-12 col-lg-12\"><div class=\"group-10 group-x-xl-40\" style=\"text-align:center;\"><p class=\"rights\"><span>Copyright ©2025冀华律师事务所 <a href=\"https://beian.miit.gov.cn/\" target=\"_blank\">冀ICP备18004099号-7</a></span></p></div></div></div>", 2))])]);
    };
  }
};